// extracted by mini-css-extract-plugin
export default {"row":"Title_row__j2voW","text":"Title_text__GaTEv"};